module.exports = __webpack_public_path__ + "img/fondo2.10f41683.png";